import React, { Component } from "react";
import fire from '../fire';
import { Feed, Button, Segment } from "semantic-ui-react";

class LessonList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contacts:[]
    };
  }

  componentDidMount() {
  
    const contactsRef = fire.database().ref('contacts');

    contactsRef.on('value', snapshot => {
      let contacts = snapshot.val();
      let newState = [];

      for (let item in contacts) {
        newState.push({
          id: item,
          name: contacts[item].name,
          date: contacts[item].date,
          comment: contacts[item].comment
        });
      }

      this.setState({
        contacts: newState
      });
    });
  }

  remove(id){
    return fire.database().ref('contacts').child(id).remove();
  }

  render(){
    return(
      <Segment basic>
        <Feed>
              {
                this.state.contacts.map(contact =>
                  <Feed.Event  key={contact.id}>
                    <Button negative compact content="Delete" onClick={() => this.remove(contact.id)} />
                    <Feed.Label icon='user' />
                    <Feed.Content date={contact.name + " " + contact.date} summary={contact.comment} />
                  </Feed.Event>
                )
              }
            </Feed>
      </Segment>
    );
  }
}
export default LessonList;